// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__wHSmk","link":"Footer_link__3+zIU"};